@if (control) {
  <div *ngIf="control?.errors && control?.dirty">
    <small class="text-red-700">{{ errorMessage | translate }}</small>
  </div>
} @else {
  <div *ngIf="formGroup?.errors && formGroup?.dirty">
    <small class="text-red-700">{{ errorMessage | translate }}</small>
  </div>
}
